
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Navigator from '../navigator';
import AppBar from './appbar';
import OrderGrid from './order-grid';
import Sidebar from './sidebar';
import SignalR from '../signalr';
import KeyHandler from '../key-handler';
import Sound from '../sound';
import { OrderDialog, DeliveryDialog } from '../components';

class Main extends Component {
  componentDidMount() {
    this.props.loadUiOptions();
    this.props.loadOrders();
  }

  render() {
    if (!this.props.loggedIn) {
      return <Redirect to="/login" />;
    }

    const { classes } = this.props;

    return (
      <Grid
        container
        direction="column"
        alignItems="stretch"
        justify="flex-start"
        wrap="nowrap"
        className={classes.root}
      >
        <Grid item>
          <AppBar className="hidePrint" />
        </Grid>

        <Grid
          item
          container
          direction="row"
          alignItems="stretch"
          justify="flex-start"
          style={{ flexGrow: 1 }}
        >
          <Grid item container xs={8} sm={9} md={10} className={classes.ordersContainer}>
            <OrderGrid />
          </Grid>

          <Grid item xs={4} sm={3} md={2} className="hidePrint" >
            <Sidebar />
          </Grid>
        </Grid>
        <Navigator />
        <SignalR />
        <Sound />
        <KeyHandler />
        <OrderDialog />
        <DeliveryDialog />
      </Grid>
    );
  }
}

Main.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  loadOrders: PropTypes.func.isRequired,
  loadUiOptions: PropTypes.func.isRequired,
};

Main.defaultProps = {
  loggedIn: false,
};

const styles = theme => ({
  root: {
    height: '100vh', overflow: 'hidden',
  },
  ordersContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: `calc(100vh - ${theme.header.height}px)`,
  },
});

export default withStyles(styles)(Main);
